import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
// import "fontawesome"
Vue.use(Vuetify);

export default new Vuetify({});
